import React, { Component } from 'react';
import { withLastLocation } from 'react-router-last-location';
import styles from './TagSelectPage.scss';
import TagSelectorController from '../../applications/main/controllers/TagSelectorController';
import { TransitionGroup } from 'react-transition-group';
import { biLogSafe } from '../../../universal/biService';
import { Fade, OnBoardingNextSkip } from '@wix/branding-client-lib';

class TagsSelectorPage extends Component {
  onSkipClicked = () => {
    const { onSkip, tagsSelected } = this.props;
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        pageName: 'Tags',
        buttonName: 'Skip',
        additionalInfo: JSON.stringify({ businessStyle: tagsSelected })
      });
    });
    onSkip();
  };

  componentDidMount() {
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorPageOpen', { pageName: 'Tags' });
    });
  }

  onNextClick() {
    const { onNext, tagsSelected } = this.props;

    onNext();
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorButtonClick', {
        pageName: 'Tags',
        buttonName: 'Next',
        additionalInfo: JSON.stringify({ businessStyle: tagsSelected })
      });
    });
  }

  render() {
    const { nextButtonText, skipButtonText } = this.props;

    return (
      <div>
        <TagSelectorController />
        <div className={styles.tagsBottomActions}>
          <TransitionGroup>
            <Fade delay={600} key="1">
              <OnBoardingNextSkip
                onNext={() => this.onNextClick()}
                onSkip={this.onSkipClicked}
                nextText={nextButtonText}
                skipText={skipButtonText}
                bng={true}
              />
            </Fade>
          </TransitionGroup>
        </div>
      </div>
    );
  }
}

export default withLastLocation(TagsSelectorPage);
